import React from 'react';

function ProgressHeader({ current, total }) {
  const percentage = (current / total) * 100;

  return (
    <header className="progress-header">
      <div className="progress-copy">
        <span>Ontdekking {current}</span>
        <strong>{current} van {total}</strong>
      </div>
      <div
        className="progress-track"
        role="progressbar"
        aria-label={`Vraag ${current} van ${total}`}
        aria-valuemin="1"
        aria-valuemax={total}
        aria-valuenow={current}
      >
        <span style={{ width: `${percentage}%` }} />
      </div>
    </header>
  );
}

export default ProgressHeader;